import { Reveal } from "@/components/motion/Reveal";

export const SectionHeading = ({ eyebrow, title, sub, align = "left", light = false }) => (
  <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    {eyebrow && (
      <Reveal>
        <span
          className={`font-mono-tech text-[12px] uppercase tracking-widest ${
            light ? "text-navy/50" : "text-cyan-precision"
          }`}
        >
          {eyebrow}
        </span>
      </Reveal>
    )}
    <Reveal delay={0.08}>
      <h2
        className={`mt-5 font-display font-light tracking-tight text-3xl sm:text-4xl lg:text-5xl leading-[1.08] ${
          light ? "text-navy" : "text-[#F0F4F8]"
        }`}
      >
        {title}
      </h2>
    </Reveal>
    {sub && (
      <Reveal delay={0.16}>
        <p className={`mt-6 text-lg leading-relaxed ${light ? "text-slate-600" : "text-[#94A3B8]"}`}>
          {sub}
        </p>
      </Reveal>
    )}
  </div>
);

export default SectionHeading;
